import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BootSpinnerComponent } from '../boot-spinner.component';

/** Shown while the OAuth callback guard exchanges the code. Frameless. */
@Component({
  selector: 'app-auth-callback',
  imports: [BootSpinnerComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<app-boot-spinner />',
})
export class AuthCallbackComponent {}
